import React from 'react';
import GameCard from '../components/GameCard';
import EmailSubscribe from '../components/EmailSubscribe';
import { gamesData } from '../data/gamesData';

const Games: React.FC = () => {
  return (
    <div className="min-h-screen bg-tal-slate-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-tal-slate-900 mb-4">Our Games</h1>
          <p className="text-xl text-tal-slate-700 max-w-3xl mx-auto">
            Immerse yourself in epic adventures where your choices shape the story.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {gamesData.map((game) => (
            <GameCard key={game.title} {...game} />
          ))}
        </div>

        <div className="mt-12 bg-white shadow-lg rounded-lg p-8 border-t-4 border-tal-brown-500">
          <div className="text-center mb-6">
            <h2 className="text-3xl font-bold text-tal-slate-900 mb-4">Stay Updated</h2>
            <p className="text-tal-slate-700 max-w-2xl mx-auto">
              Be the first to know about new game releases, updates, and exclusive content.
              Subscribe to our newsletter!
            </p>
          </div>
          <EmailSubscribe variant="inline" className="max-w-2xl mx-auto" />
        </div>
      </div>
    </div>
  );
};

export default Games;
